import React, { Component } from 'react';
import InventoryNav from '../inventory/InventoryNav';

import {
    InventoryInstrument
} from 'types/drupal/InstrumentNode';

import BreadcrumbTrail from 'components/global/application/BreadcrumbTrail';
import { BREAK_POINT } from 'constants/responsive';
import FontAwesome from 'react-fontawesome';
import Disclaimer from '../inventory/Disclaimer';
import InventoryItem from '../inventory/InventoryItem';

export default class NewArrivalsPage extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.props.getNewArrivals();
    }

    public render() {
        return window.innerWidth < BREAK_POINT ? this.renderMobile() : this.renderDesktop();
    }

    private renderMobile() {
        return (
            <div className="row Inventory-container-mobile">
            <div className="col-12 Breadcrumb">
                <BreadcrumbTrail
                    pathNodes={[
                        { label:'Home', route:'/' },
                        { label: 'Instruments & Amps', route: '/inventory' },
                        { label: 'New Arrivals', route: '/instruments/new-arrivals' }
                    ]}
                />
            </div>
            <div className="col-10 offset-1 ResultsTitle">&nbsp;</div>
            <div className="col-10 offset-1 Guitars">
            {!this.props.newArrivals ?
                (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />)
                : this.props.newArrivals.length < 1
                    ?
                    <div className="No-results-text" >
                        There are no new arrivals at this time, check back later
                    </div>
                    : this.props.newArrivals.map((gt: any) => {
                        // Display items in rows of two
                        return <div key={gt.nid} className="col-6"><InventoryItem isMobile={true} item={gt} /></div>;
                    }).reduce(
                        (prev: JSX.Element[][], cur: JSX.Element, index: number) => {
                            if (index % 2 === 0) prev.push(Array());
                            prev[prev.length - 1].push(cur);
                            return prev;
                        },
                        []  // <- Initial value to reduce into
                    ).map((subElms: JSX.Element[]) => {
                        return (
                        <div className="row" key={subElms.map(cur => cur.key).join()} >
                        {subElms}
                        </div>);
                    })
            }
            </div>
            <div className="col-12">
                <Disclaimer />
            </div>
        </div>
        );

    }
    private renderDesktop() {
        return (
            <div className="Inventory-container row">
                <div className="offset-1 col-10">
                    <div className="row">
                        <div className="col-4">
                            <div className="Side-pane">
                                <InventoryNav />
                                <hr /> {/* TODO: Replace this with something better */}
                            </div>
                        </div>
                        <div className="col-8 Results-area">
                            <div className="Results-breadcrumb">
                                <BreadcrumbTrail
                                    pathNodes={[
                                        { label:'Home', route:'/' },
                                        { label: 'Instruments & Amps', route: '/inventory' },
                                        { label: 'New Arrivals', route: '/instruments/new-arrivals' }
                                    ]}
                                />
                            </div>
                            <div className="ResultsTitle">
                                New Arrivals
                            </div>
                            {
                                // We need to put in the none found message too below
                                !this.props.newArrivals ?
                                    <FontAwesome className="loading-spinner" name="spinner" size="3x" spin /> :
                                    this.props.newArrivals.length < 1 ?
                                    <div className="No-results-text" >
                                        There are no new arrivals at this time, check back later
                                     </div> :
                                    this.props.newArrivals.map((intsr: InventoryInstrument) => {
                                        return (
                                            <div key={intsr.nid} className="col-3">
                                                <InventoryItem isMobile={false} item={intsr} />
                                            </div>
                                        );
                                    }).reduce((prev: JSX.Element[][], cur: JSX.Element, index: number) => {
                                        if (index % 4 === 0) prev.push(Array());
                                        prev[prev.length - 1].push(cur);
                                        return prev;
                                    },
                                              [])
                                        .map((subElms: JSX.Element[]) => {
                                            return <div
                                                className="row"
                                                key={subElms.map((cur: JSX.Element) => {
                                                    return cur.key;
                                                }).join()}
                                            >
                                            {subElms}
                                            </div>;
                                        })
                            }
                            <hr />
                            <Disclaimer />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/NewArrivalsPage/NewArrivalsPage.tsx